import React, { FC } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const IndividualBankDetailsForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }
  const { dropdownOptions } = useDropdownOptions()

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData
  } = useForm(
    props.fetchedData,
    config({ countries: dropdownOptions.countries, currencies: dropdownOptions.currencies }),
    submitForm
  )

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.BankDetailsForm.title')}</FormTitle>
        <FormDescription>
          {t('onboarding.forms.IndividualAccount.BankDetailsForm.description')}
        </FormDescription>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualBankDetailsForm
